<template>
  <div class="saas-dashboard__row-usage">
    <div class="saas-dashboard__row-usage-progress-bar">
      <div class="saas-dashboard__row-usage-text">
        {{ $t('common.rowUsage') }}
        <div class="saas-dashboard__row-usage-count">
          <strong>{{ workspaceUsage.row_count }}</strong>
          <span>/ {{ workspaceUsage.rows_quota }}</span>
        </div>
      </div>
      <ProgressBar
        :progress="workspaceUsage.row_count"
        :total="workspaceUsage.rows_quota"
        class="saas-dashboard__row-usage-progress-bar-component"
      />
    </div>

    <template
      v-if="
        workspaceUsage.license_type === null &&
        workspaceUsage.user_can_manage_subscription &&
        workspaceUsage.previous_trial === false
      "
    >
      <Button type="secondary" @click="$refs.startTrialModal.show()">
        {{ $t('trials.getFreeTrial') }}
      </Button>
      <StartTrialModal
        ref="startTrialModal"
        :workspace="workspace"
        @success="trialStarted()"
      />
    </template>
    <Button
      v-else-if="workspaceUsage.user_can_manage_subscription"
      type="secondary"
      @click="upgrade"
    >
      {{ $t('common.changePlan') }}</Button
    >

    <div class="tooltip tooltip--center saas-dashboard__row-usage-tooltip">
      <div class="tooltip__content saas-dashboard__usage-tooltip-content">
        <WorkspaceUsageTooltipList
          :workspace-usage="workspaceUsage"
        ></WorkspaceUsageTooltipList>
      </div>
    </div>
  </div>
</template>

<script>
import ProgressBar from '@saas/components/ProgressBar'
import StartTrialModal from '@saas/components/subscriptions/StartTrialModal'
import WorkspaceUsageTooltipList from '@saas/components/dashboard/WorkspaceUsageTooltipList'
import { getChangePlanRoute } from '@saas/utils/subscription'

export default {
  name: 'DashboardWorkspaceRowUsage',
  components: { ProgressBar, StartTrialModal, WorkspaceUsageTooltipList },
  emits: ['workspace-updated'],
  props: {
    workspace: {
      type: Object,
      required: true,
    },
    componentArguments: {
      type: Object,
      required: true,
    },
  },
  computed: {
    workspaceUsage() {
      return this.componentArguments.usageData.find(
        (u) => u.workspace_id === this.workspace.id
      )
    },
  },
  methods: {
    upgrade() {
      this.$router.push(getChangePlanRoute(this.workspaceUsage))
    },
    trialStarted() {
      this.$emit('workspace-updated', this.workspace)
    },
  },
}
</script>
